var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M425.97 699.31C257.26 645.66 253.76 544.71 151.93 483.69C103 454.36 23.06 452.95 -24.97 465.26",
    id: "d18JgoAbB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M425.97 699.31C257.26 645.66 253.76 544.71 151.93 483.69C103 454.36 23.06 452.95 -24.97 465.26",
    id: "hv37MiaLt"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M716.96 599.47C716.96 599.47 626.42 614.22 542.8 611.26C471.21 608.73 373.34 564.99 312.49 558.42C230.46 549.55 162.66 594.78 13.17 562.17C-33.66 551.95 -92.14 515.96 -92.14 515.96",
    id: "c2JEQr1Ucz"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M716.96 599.47C716.96 599.47 626.42 614.22 542.8 611.26C471.21 608.73 373.34 564.99 312.49 558.42C230.46 549.55 162.66 594.78 13.17 562.17C-33.66 551.95 -92.14 515.96 -92.14 515.96",
    id: "b3iFLpRVVQ"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-91.08 482.47C-91.41 493.67 -93.1 549.68 -96.14 650.5C-15.06 653.37 633.56 676.34 714.64 679.21C715.41 653.88 715.83 639.81 715.92 636.99C680.43 651.48 622.43 671.59 541.15 668.71C318.24 660.82 230.31 499.67 83.43 467.17C9.37 451.45 -44.34 477.47 -91.08 482.47Z",
    id: "aJlz38RxZ"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientc3h7mOmGo",
    gradientUnits: "userSpaceOnUse",
    x1: 332.81,
    y1: 543.98,
    x2: 291.03,
    y2: 617.22
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#001d99",
      stopOpacity: 0
    },
    offset: "100%"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-91.08 482.47C-91.41 493.67 -93.1 549.68 -96.14 650.5C-15.06 653.37 633.56 676.34 714.64 679.21C715.41 653.88 715.83 639.81 715.92 636.99C680.43 651.48 622.43 671.59 541.15 668.71C318.24 660.82 230.31 499.67 83.43 467.17C9.37 451.45 -44.34 477.47 -91.08 482.47Z",
    id: "d1WS2M95J2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M716.19 623.34C685.84 622.27 611.71 619.64 556.55 603.37C506.12 588.49 479.23 573.81 443.77 566.29C383.63 553.51 321.48 589.32 227.16 585.23C151.6 581.99 106.07 563.43 80.65 553.7C31.87 531.27 -56.54 478.44 -90.1 444.44",
    id: "a4ZUGG0qd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M716.19 623.34C685.84 622.27 611.71 619.64 556.55 603.37C506.12 588.49 479.23 573.81 443.77 566.29C383.63 553.51 321.48 589.32 227.16 585.23C151.6 581.99 106.07 563.43 80.65 553.7C31.87 531.27 -56.54 478.44 -90.1 444.44",
    id: "a28YzMQ9yC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M227.24 585.23C151.68 581.99 106.15 563.43 80.73 553.7C31.95 531.27 -56.46 478.44 -90.02 444.44C-90.43 458.18 -92.5 526.9 -96.23 650.59C-15.15 653.46 633.47 676.43 714.55 679.3C715.53 646.76 716.08 628.68 716.19 625.07C685.87 623.99 615.83 622.41 543.16 599.13C506.1 587.26 476.48 573.35 441.03 565.8C384.09 553.44 321.56 589.29 227.24 585.23Z",
    id: "c3dNdOiGQ"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradienta7H0l2NSU",
    gradientUnits: "userSpaceOnUse",
    x1: 313.14,
    y1: 532.8,
    x2: 311.35,
    y2: 592.29
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#0a19a3",
      stopOpacity: 0.5
    },
    offset: "100%"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M227.24 585.23C151.68 581.99 106.15 563.43 80.73 553.7C31.95 531.27 -56.46 478.44 -90.02 444.44C-90.43 458.18 -92.5 526.9 -96.23 650.59C-15.15 653.46 633.47 676.43 714.55 679.3C715.53 646.76 716.08 628.68 716.19 625.07C685.87 623.99 615.83 622.41 543.16 599.13C506.1 587.26 476.48 573.35 441.03 565.8C384.09 553.44 321.56 589.29 227.24 585.23Z",
    id: "bbU9BGT58"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73 506.51C5.72 506.72 5.55 506.89 5.34 506.88C5.13 506.88 4.97 506.7 4.98 506.48C4.98 506.27 5.16 506.1 5.36 506.11C5.57 506.12 5.74 506.29 5.73 506.51Z",
    id: "eCZfCJ1e3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73 506.51C5.72 506.72 5.55 506.89 5.34 506.88C5.13 506.88 4.97 506.7 4.98 506.48C4.98 506.27 5.16 506.1 5.36 506.11C5.57 506.12 5.74 506.29 5.73 506.51Z",
    id: "b12zBJBdkt"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.28 514.03C-3.29 514.25 -3.46 514.42 -3.67 514.41C-3.88 514.4 -4.04 514.22 -4.03 514.01C-4.03 513.79 -3.85 513.63 -3.65 513.63C-3.44 513.64 -3.27 513.82 -3.28 514.03Z",
    id: "g28BNExOk4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.28 514.03C-3.29 514.25 -3.46 514.42 -3.67 514.41C-3.88 514.4 -4.04 514.22 -4.03 514.01C-4.03 513.79 -3.85 513.63 -3.65 513.63C-3.44 513.64 -3.27 513.82 -3.28 514.03Z",
    id: "cRIALqWOR"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M600.35 242.73C600.35 242.99 600.57 243.2 600.83 243.2C601.09 243.2 601.3 242.99 601.3 242.73C601.3 242.47 601.09 242.26 600.83 242.26C600.57 242.26 600.35 242.47 600.35 242.73Z",
    id: "bSZtNpcRQ"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M600.35 242.73C600.35 242.99 600.57 243.2 600.83 243.2C601.09 243.2 601.3 242.99 601.3 242.73C601.3 242.47 601.09 242.26 600.83 242.26C600.57 242.26 600.35 242.47 600.35 242.73Z",
    id: "b8mB5Ng4m"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-208.44 376.11C-208.45 376.33 -208.62 376.49 -208.83 376.49C-209.04 376.48 -209.2 376.3 -209.19 376.09C-209.19 375.87 -209.01 375.7 -208.81 375.71C-208.6 375.72 -208.44 375.9 -208.44 376.11Z",
    id: "cGgCS3Ls2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-208.44 376.11C-208.45 376.33 -208.62 376.49 -208.83 376.49C-209.04 376.48 -209.2 376.3 -209.19 376.09C-209.19 375.87 -209.01 375.7 -208.81 375.71C-208.6 375.72 -208.44 375.9 -208.44 376.11Z",
    id: "b1ww95QeTu"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M605.16 247.61C605.16 247.87 605.37 248.08 605.63 248.08C605.9 248.08 606.11 247.87 606.11 247.61C606.11 247.35 605.9 247.14 605.63 247.14C605.37 247.14 605.16 247.35 605.16 247.61Z",
    id: "bNMejoHDu"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M605.16 247.61C605.16 247.87 605.37 248.08 605.63 248.08C605.9 248.08 606.11 247.87 606.11 247.61C606.11 247.35 605.9 247.14 605.63 247.14C605.37 247.14 605.16 247.35 605.16 247.61Z",
    id: "c2J5sWPoS2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-210.78 369.17C-210.79 369.38 -210.96 369.55 -211.17 369.54C-211.38 369.54 -211.54 369.36 -211.54 369.14C-211.53 368.93 -211.36 368.76 -211.15 368.77C-210.94 368.78 -210.78 368.96 -210.78 369.17Z",
    id: "f9B1qgU"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-210.78 369.17C-210.79 369.38 -210.96 369.55 -211.17 369.54C-211.38 369.54 -211.54 369.36 -211.54 369.14C-211.53 368.93 -211.36 368.76 -211.15 368.77C-210.94 368.78 -210.78 368.96 -210.78 369.17Z",
    id: "d4nwI9beZl"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M603.34 233.88C603.34 234.15 603.55 234.36 603.81 234.36C604.07 234.36 604.29 234.15 604.29 233.88C604.29 233.62 604.07 233.41 603.81 233.41C603.55 233.41 603.34 233.62 603.34 233.88Z",
    id: "ei3EPRPRf"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M603.34 233.88C603.34 234.15 603.55 234.36 603.81 234.36C604.07 234.36 604.29 234.15 604.29 233.88C604.29 233.62 604.07 233.41 603.81 233.41C603.55 233.41 603.34 233.62 603.34 233.88Z",
    id: "b7plTHf0uK"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-217.45 383.67C-217.46 383.88 -217.63 384.05 -217.84 384.04C-218.05 384.04 -218.21 383.86 -218.21 383.64C-218.2 383.43 -218.03 383.26 -217.82 383.27C-217.61 383.28 -217.45 383.45 -217.45 383.67Z",
    id: "b33C1Mg9WZ"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M-217.45 383.67C-217.46 383.88 -217.63 384.05 -217.84 384.04C-218.05 384.04 -218.21 383.86 -218.21 383.64C-218.2 383.43 -218.03 383.26 -217.82 383.27C-217.61 383.28 -217.45 383.45 -217.45 383.67Z",
    id: "d1cYJ17Bkl"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d18JgoAbB",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d18JgoAbB",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hv37MiaLt",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hv37MiaLt",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2JEQr1Ucz",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2JEQr1Ucz",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3iFLpRVVQ",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3iFLpRVVQ",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aJlz38RxZ",
    opacity: 0.05,
    fill: "url(#gradientc3h7mOmGo)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aJlz38RxZ",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1WS2M95J2",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1WS2M95J2",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4ZUGG0qd",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4ZUGG0qd",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a28YzMQ9yC",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a28YzMQ9yC",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3dNdOiGQ",
    opacity: 0.05,
    fill: "url(#gradienta7H0l2NSU)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3dNdOiGQ",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bbU9BGT58",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bbU9BGT58",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eCZfCJ1e3",
    opacity: 0.05,
    fill: "#00bdff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eCZfCJ1e3",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b12zBJBdkt",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b12zBJBdkt",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g28BNExOk4",
    opacity: 0.05,
    fill: "#00bdff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g28BNExOk4",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cRIALqWOR",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cRIALqWOR",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bSZtNpcRQ",
    opacity: 0.05,
    fill: "#00bdff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bSZtNpcRQ",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b8mB5Ng4m",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b8mB5Ng4m",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cGgCS3Ls2",
    opacity: 0.05,
    fill: "#00bdff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cGgCS3Ls2",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1ww95QeTu",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1ww95QeTu",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bNMejoHDu",
    opacity: 0.05,
    fill: "#00bdff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bNMejoHDu",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2J5sWPoS2",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2J5sWPoS2",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f9B1qgU",
    opacity: 0.05,
    fill: "#00bdff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f9B1qgU",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4nwI9beZl",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4nwI9beZl",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ei3EPRPRf",
    opacity: 0.05,
    fill: "#00bdff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ei3EPRPRf",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7plTHf0uK",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7plTHf0uK",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b33C1Mg9WZ",
    opacity: 0.05,
    fill: "#00bdff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b33C1Mg9WZ",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1cYJ17Bkl",
    opacity: 0.05,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1cYJ17Bkl",
    opacity: 0.05,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/background.f020801c685c85b74ce409b625dd8d88.svg";